const Levels = 
  {
    NONE    : 0,
    ERROR   : 1,
    WARN    : 2,
    INFO    : 3,
    DEBUG   : 4
  };

export { Levels };